// src/pages/parts/GroupDetail.js
import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';

// 1. Add filterOrg to props
const GroupDetail = ({ group, filterOrg }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (group) {
      setLoading(true);
      // Fetch users based on the group role (e.g., 'admin', 'manager')
      apiService.getUsersByRole(group.roleKey)
        .then(data => {
          setUsers(data || []);
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setUsers([]);
          setLoading(false);
        });
    }
  }, [group]);

  if (!group) return <div className="group-detail-placeholder">Select a group</div>;

  // 2. Apply the Organisation Filter
  const filteredUsers = filterOrg === 'All' 
    ? users 
    : users.filter(user => user.organisation === filterOrg);

  return (
    <div className="group-detail-container" style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '8px', flex: 1 }}>
      <div className="detail-header" style={{ borderBottom: '1px solid #e5e7eb', paddingBottom: '1rem', marginBottom: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <span style={{ fontSize: '2rem' }}>{group.icon}</span>
          <div>
            <h2 style={{ margin: 0 }}>{group.name}</h2>
            <p style={{ margin: '0.25rem 0 0', color: '#6b7280' }}>{group.description}</p>
          </div>
        </div>
      </div>

      <div className="permissions-section" style={{ marginBottom: '2rem' }}>
        <h4 style={{ textTransform: 'uppercase', fontSize: '0.75rem', color: '#9ca3af', letterSpacing: '0.05em' }}>Permissions</h4>
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>
          {group.permissions.map(perm => (
            <span key={perm} style={{ background: '#f3f4f6', padding: '0.25rem 0.75rem', borderRadius: '999px', fontSize: '0.85rem', color: '#374151' }}>
              {perm}
            </span>
          ))}
        </div>
      </div>

      <div className="users-section">
        <h3 style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
          Users ({filteredUsers.length})
          {filterOrg !== 'All' && <span style={{ fontWeight: 'normal', fontSize: '0.9rem', color: '#6b7280' }}> in {filterOrg}</span>}
        </h3>

        {loading ? (
          <div>Loading users...</div>
        ) : filteredUsers.length === 0 ? (
          <div style={{ padding: '1rem', background: '#f9fafb', borderRadius: '6px', color: '#6b7280', textAlign: 'center' }}>
            No users found in this group for the selected organisation.
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#6b7280', fontSize: '0.9rem', borderBottom: '1px solid #e5e7eb' }}>
                <th style={{ padding: '0.75rem 0' }}>Name</th>
                <th style={{ padding: '0.75rem 0' }}>Email</th>
                <th style={{ padding: '0.75rem 0' }}>Organisation</th>
                <th style={{ padding: '0.75rem 0' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map(user => (
                <tr key={user.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td style={{ padding: '0.75rem 0', fontWeight: '500' }}>{user.username}</td>
                  <td style={{ padding: '0.75rem 0', color: '#6b7280' }}>{user.email}</td>
                  <td style={{ padding: '0.75rem 0' }}>{user.organisation}</td>
                  <td style={{ padding: '0.75rem 0' }}>
                    <span style={{ 
                      padding: '0.25rem 0.5rem', 
                      borderRadius: '4px', 
                      fontSize: '0.8rem',
                      backgroundColor: user.status === 'Active' ? '#dcfce7' : '#f3f4f6',
                      color: user.status === 'Active' ? '#166534' : '#374151'
                    }}>
                      {user.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default GroupDetail;
